// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BillingSystem\ApiBillingSystem.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { ApprovalOfCharges, ApprovalOfChargesData, ApprovalOfChargesOptions } from 'data/models/ApprovalOfCharges';
import { Bill, BillData, BillOptions } from 'data/models/Bill';
import { ExportPayload, ExportPayloadData, ExportPayloadOptions } from 'data/models/ExportPayload';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { QuickBooksBillingSystemTracking, QuickBooksBillingSystemTrackingData, QuickBooksBillingSystemTrackingOptions } from 'data/models/QuickBooksBillingSystemTracking';
import { Rate, RateData, RateOptions } from 'data/models/Rate';
import { StandardItem, StandardItemData, StandardItemOptions } from 'data/models/StandardItem';

// BillingSystemData is the class that BillingSystem serializes to/from
export interface BillingSystemData {
    Id : number;
	
    ApprovalsOfCharges : ApprovalOfChargesData[] | null;
    Bills : BillData[] | null;
    ExportPayloads : ExportPayloadData[] | null;
    Organization : OrganizationData | null;
    OrganizationId : number;
    SpecialRates : RateData[] | null;
    StandardItems : StandardItemData[] | null;
	
    Currency : string;
    QBTracking : QuickBooksBillingSystemTrackingData;
}

// BillingSystemOptions is the class which may be passed to the BillingSystem constructor to define optional initial data values
export interface BillingSystemOptions {
    Id : number;
	
    ApprovalsOfCharges? : ApprovalOfChargesOptions[] | null;
    Bills? : BillOptions[] | null;
    ExportPayloads? : ExportPayloadOptions[] | null;
    Organization? : OrganizationOptions | null;
    OrganizationId? : number;
    SpecialRates? : RateOptions[] | null;
    StandardItems? : StandardItemOptions[] | null;
	
    Currency? : string;
    QBTracking? : QuickBooksBillingSystemTrackingOptions;
}

export class BillingSystem {
    public Id : DataSignal<number>;
	
    public ApprovalsOfCharges : SDataArray<ApprovalOfCharges>;
    public Bills : SDataArray<Bill>;
    public ExportPayloads : SDataArray<ExportPayload>;
    public Organization : DataSignal<Organization | null>;
    public OrganizationId : DataSignal<number>;
    public SpecialRates : SDataArray<Rate>;
    public StandardItems : SDataArray<StandardItem>;
	
    public Currency : DataSignal<string>;
    public QBTracking : QuickBooksBillingSystemTracking;

    constructor();
    constructor(data : BillingSystemOptions);
    constructor(data: BillingSystemOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.ApprovalsOfCharges = SArray<ApprovalOfCharges>([]);
        this.Bills = SArray<Bill>([]);
        this.ExportPayloads = SArray<ExportPayload>([]);
        this.Organization = S.value<Organization | null>(null);
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.SpecialRates = SArray<Rate>([]);
        this.StandardItems = SArray<StandardItem>([]);
	    
        this.Currency = jsonableObservable(S.value<string>(data && data.Currency !== undefined ? data.Currency : ''));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksBillingSystemTracking(data.QBTracking) : new QuickBooksBillingSystemTracking();
    }

    static key(obj : BillingSystem) {
        return obj.Id();
    }
    
    static dataKey(obj : BillingSystemOptions) {
        return obj.Id;
    }

    static update(obj : BillingSystem, data : BillingSystemOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
	        
            if (data.Currency !== undefined) obj.Currency(data.Currency);
            if (data.QBTracking !== undefined) QuickBooksBillingSystemTracking.update(obj.QBTracking, data.QBTracking);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BillingSystem.ts